import { formatDistanceStrict } from 'date-fns';
import { ptBR } from 'date-fns/locale';

// Negócio "parado": aberto e na mesma etapa há mais tempo do que a coluna
// tolera (crm_funnel_stages.stale_after_hours). Ganho e perdido nunca contam:
// são desfecho, não abandono. Vive fora do card porque a coluna precisa da
// mesma conta pra dizer "3 parados" no cabeçalho.
export const staleInfo = (card, staleAfterHours, now = Date.now()) => {
  if (!staleAfterHours) return null;
  if (card.custom_attributes?.deal_status !== 'open') return null;
  const enteredAt = card.custom_attributes?.deal_stage_entered_at;
  if (!enteredAt) return null;

  const entered = new Date(enteredAt).getTime();
  if (Number.isNaN(entered)) return null;
  if (now - entered < staleAfterHours * 3600 * 1000) return null;

  return {
    label: `parado há ${formatDistanceStrict(entered, now, { locale: ptBR })}`,
  };
};
